import classNames from 'classnames';
import { StatDisplay, StatDisplayProps } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { BatteryIcon } from 'app/agriculture/icons/BatteryIcon';
import './BatteryStat.scss';
import { Skeleton } from '@mui/material';

export function BatteryStatSkeleton({
    className,
    ...statDisplayProps
}: Exclude<StatDisplayProps, 'value'>) {
    return (
        <StatDisplay
            {...statDisplayProps}
            className={classNames(className, 'BatteryStat')}
            Icon={({ className, ...props }) => (
                <BatteryIcon
                    {...props}
                    color="#eee"
                    className={classNames(className, 'BatteryStat__icon')}
                    size={32}
                />
            )}
            value={<Skeleton variant="text" width={24} />}
            unit="%"
        />
    );
}
